import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DefaultButton from "../../../shared/components/DefaultButton";
import { BACKTOLIST } from "../../../shared/constants/Constants";
import NotificationForm from "./NotificationForm";

const AddNewNotification = () => {
  let navigate = useNavigate();

  return (
    <>
      <Row className="align-items-start">
        <Col md={12} >
          <NotificationForm isNewNotification={true} />
        </Col>
      </Row>
    </>
  );
};

export default AddNewNotification;
